import { render, staticRenderFns } from "./group-editor.vue?vue&type=template&id=2b859bb7"
import script from "./group-editor.vue?vue&type=script&lang=js"
export * from "./group-editor.vue?vue&type=script&lang=js"
import style0 from "./group-editor.vue?vue&type=style&index=0&id=2b859bb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports